import LanguageStringResolver from "../fields/language/LanguageStringResolver";
import React from "react";

const LanguageTranslationPanel = props => {
    const {isEngTranslated, translationAvailable, handleClick} = props;
    /*
     Below key initialised in /reporting-saas-ui/scripts/deploy/docker-compose-local.sh
    */
    const buttonTitle = ['Eng_LanguageTranslationConversion_SalesPurchaseLedger', 'Native_LanguageTranslationConversion_SalesPurchaseLedger'];
    
    return (
        <>
            { translationAvailable &&
            <button className="button secondary"
                data-testid="btn-language-conversion-sales-purchase" onClick={handleClick}>
                {<LanguageStringResolver string={ isEngTranslated ? buttonTitle[1] : buttonTitle[0] }/>}
            </button>
            }
        </>)
}


LanguageTranslationPanel.defaultProps = {
    isEngTranslated: false,
    translationAvailable: false
};
export default LanguageTranslationPanel;